import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useRef, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useTheme } from "@mui/material/styles";
import Countdown from "react-countdown";
import { useRequest } from "../../api/utils/useRequest";
import { AccountAPIs } from "../../api/APIs";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { LoadingButton } from "@mui/lab";
import BalootOTPInput from "../../components/shared/BalootOTPInput";

function ForgotPasswordOTPPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const mobile = location.state.mobile;
  const theme = useTheme();
  const countdown = useRef(null);
  const [timerCompleted, setTimerCompleted] = useState(false);
  const [timerDate, setTimerDate] = useState(Date.now() + 120000);
  const [timerKey, setTimerKey] = useState(1);
  const [otp, setOtp] = useState("");

  const { apiCall: sendForgotPasswordOTP, loading: resendLoading } = useRequest(
    AccountAPIs.sendForgotPasswordOTP
  );
  const { apiCall: confirmForgotPasswordOTP, loading: confirmLoading } =
    useRequest(AccountAPIs.confirmForgotPasswordOTP);

  const resendHandler = () => {
    sendForgotPasswordOTP({
      data: { mobile: mobile },
      onSuccess: () => {
        setTimerKey((prev) => prev + 1);
        countdown.current.start();
      },
    });
  };

  const registerHandler = () => {
    confirmForgotPasswordOTP({
      data: { mobile: mobile, otp: otp },
      onSuccess: (response) => {
        if (response.list.length === 0) {
          navigate("/auth/set-password/set", {
            state: { mobile: mobile },
            replace: true,
          });
        } else {
          navigate("../forgot-password", {
            state: { mobile: mobile, list: response.list },
            replace: true,
          });
        }
      },
    });
  };

  useEffect(() => {
    if (otp.length === 5) {
      registerHandler();
    }
  }, [otp]);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              navigate(-1);
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            فراموشی رمز عبور
          </Typography>
        }
      />

      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography
            component={"div"}
            variant="body1"
            color={"grey.4"}
            align="center"
          >
            کد فعال‌سازی به شماره{" "}
            <Box display={"inline"} color={"grey.2"} typography={"h4"}>
              {mobile}
            </Box>{" "}
            ارسال شد. کد دریافتی را اینجا وارد کنید
          </Typography>
          <Box
            sx={{
              mt: "12px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              direction: "ltr",
            }}
          >
            <BalootOTPInput otp={otp} setOtp={setOtp} />
          </Box>
          <Box
            sx={{
              mt: "24px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: !timerCompleted ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <CountdownCircleTimer
                size={28}
                key={timerKey}
                strokeWidth={2}
                isPlaying
                duration={120}
                colors={[[theme.palette.grey[2], 1]]}
              />
              <Countdown
                ref={countdown}
                date={timerDate}
                renderer={({ minutes, seconds, completed }) => {
                  return (
                    <Box display="flex" justifyContent="flex-end" mt={1}>
                      <Typography variant="body1" color={"grey.2"}>
                        {("00" + minutes).slice(-2)}:
                        {("00" + seconds).slice(-2)}
                      </Typography>
                    </Box>
                  );
                }}
                onComplete={() => setTimerCompleted(true)}
                onStart={() => {
                  setTimerDate(Date.now() + 120000);
                  setTimerCompleted(false);
                }}
              />
            </Box>
            <LoadingButton
              loading={resendLoading}
              sx={{
                display: timerCompleted ? "block" : "none",
              }}
              variant="text"
              size="small"
              onClick={resendHandler}
            >
              ارسال مجدد کد تایید
            </LoadingButton>
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            mt: 1,
          }}
        >
          <Box>
            <LoadingButton
              disabled={otp.length < 5}
              onClick={registerHandler}
              loading={confirmLoading}
              variant="contained"
              color="primary"
              sx={{ height: 56, width: 48 }}
            >
              <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
            </LoadingButton>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default ForgotPasswordOTPPage;
